import { cloneDeep } from 'lodash';
import React from 'react';
import { InputAdornment } from '@material-ui/core';
import { formatAsFloat } from '../../../../../../utils/utils';
import { ADDITIONAL_CHARGES_PRECISION } from '../../../../../../constants/decimal-points';

const MINIMUM_INVOICE_AMOUNT = 'MINIMUM_INVOICE_AMOUNT';
const FLAT = 'FLAT';
const PERCENT = 'PERCENT';

const serviceChargeFormatter = {
  [FLAT]: {
    startAdornment: <InputAdornment position="start">$</InputAdornment>,
    startAdornmentSymbol: '$',
    endAdornmentSymbol: '',
    getBaseValue: (serviceCharge) => serviceCharge.baseServiceChargeFlat,
    getAdjustedValue: (serviceCharge) =>
      serviceCharge.adjustedServiceChargeFlat,
    getUpdated: (serviceCharge, value) => {
      const updatedServiceCharge = cloneDeep(serviceCharge);
      updatedServiceCharge.adjustedServiceChargeFlat = value;
      return updatedServiceCharge;
    }
  },
  [PERCENT]: {
    endAdornment: <InputAdornment position="end">%</InputAdornment>,
    startAdornmentSymbol: '',
    endAdornmentSymbol: '%',
    getBaseValue: (serviceCharge) => serviceCharge.baseServiceChargePercent,
    getAdjustedValue: (serviceCharge) =>
      serviceCharge.adjustedServiceChargePercent,
    getUpdated: (serviceCharge, value) => {
      const updatedServiceCharge = cloneDeep(serviceCharge);
      updatedServiceCharge.adjustedServiceChargePercent = value;
      return updatedServiceCharge;
    }
  },
  [MINIMUM_INVOICE_AMOUNT]: {
    startAdornment: <InputAdornment position="start">$</InputAdornment>,
    startAdornmentSymbol: '$',
    endAdornmentSymbol: '',
    getBaseValue: (serviceCharge) => serviceCharge.value,
    getAdjustedValue: (serviceCharge) => serviceCharge.value
  }
};

const getServiceChargeValue = (
  serviceCharge,
  roundValues,
  includeAdornments = false
) => {
  const formatter = serviceChargeFormatter[serviceCharge.serviceChargeType];
  const value = formatter.getAdjustedValue(serviceCharge);
  const chargeValue = roundValues
    ? formatAsFloat(value, ADDITIONAL_CHARGES_PRECISION)
    : value;

  return !includeAdornments
    ? chargeValue
    : `${formatter.startAdornmentSymbol}${chargeValue}${formatter.endAdornmentSymbol}`;
};

const getServiceChargeBaseValue = (
  serviceCharge,
  roundValues,
  includeAdornments = false
) => {
  const formatter = serviceChargeFormatter[serviceCharge.serviceChargeType];
  const value = formatter.getBaseValue(serviceCharge);
  const chargeValue = roundValues
    ? formatAsFloat(value, ADDITIONAL_CHARGES_PRECISION)
    : value;
  return !includeAdornments
    ? chargeValue
    : `${formatter.startAdornmentSymbol}${chargeValue}${formatter.endAdornmentSymbol}`;
};

const getServiceChargeStartAdornment = (serviceCharge) =>
  serviceChargeFormatter[serviceCharge.serviceChargeType].startAdornment;
const getServiceChargeEndAdornment = (serviceCharge) =>
  serviceChargeFormatter[serviceCharge.serviceChargeType].endAdornment;

const getUpdatedServiceCharge = (serviceCharge, value) =>
  serviceChargeFormatter[serviceCharge.serviceChargeType].getUpdated(
    serviceCharge,
    value
  );

export {
  getUpdatedServiceCharge,
  getServiceChargeValue,
  getServiceChargeBaseValue,
  getServiceChargeStartAdornment,
  getServiceChargeEndAdornment,
  MINIMUM_INVOICE_AMOUNT
};
